import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { useAppState } from "../../store";

export const UnauthenticatedRoute: React.FC<RouteProps> = ({
  children,
  ...rest
}: any) => {
  const { user } = useAppState();
  return (
    <Route
      {...rest}
      render={() => (user.isAuthenticated ? <Redirect to="/" /> : children)}
    />
  );
};
